import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import { ConfigProvider } from "antd";
// import './App.css';

import Layout from "./container/layoutMain/index";
// import Login from "./pages/login";
// import HomePage from "../src/pages/home/index";
// import DeviceRoom from "./pages/deviceRoom";
// import DeviceHome from "../src/pages/deviceHome";

import Login from "./pages/loginP";
import HomePage from "../src/pages/homeP/index";
import DeviceRoom from "./pages/deviceRoomP";
import DeviceHome from "../src/pages/deviceHomeP";
import MasterName from "../src/pages/mastName";


import { getUserlogin } from "./stored/mydata";

function App() {
  const userlogin = useSelector(getUserlogin);

  const PrivateRoute = ({ auth: { isAuthenticated }, children }) => {
    
    if (isAuthenticated) {
      return children;
    } else {
      return <Navigate to="/" />;
    }
  };

  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route
        path="/"
        element={
          <PrivateRoute auth={{ isAuthenticated: userlogin }}>
            <Layout />
          </PrivateRoute>
        }
      >
        <Route path="home" element={<HomePage />} />
        <Route path="deviceroom" element={<DeviceRoom />} />
        <Route path="devicehome" element={<DeviceHome />} />
        <Route path="mastername" element={<MasterName />} />
      </Route>
    </Routes>
  );
}

export default App;
